export default {
      id: "plantSatelliteHover-usage",
      viewBox: "0 0 50 50",
      url: __webpack_public_path__ + "icons.svg#plantSatelliteHover",
      toString: function () {
        return this.url;
      }
    }